import type { TableSortState } from '../UI';

// The name column's sort key, shared because the default sort below has to
// point at the same column `getPatientColumns` renders.
export const PATIENT_NAME_COLUMN_KEY = 'name' as const;

// The list opens ordered by name rather than in whatever order the backend
// returned it. Looking a patient up by name is what nearly every visit to this
// page is for, so having to click the header first was work with no decision
// behind it (REH-337). The alphabet itself comes from the table's comparator,
// which is pinned to Danish (A to Å) for every user, not from here.
export const DEFAULT_PATIENTS_SORT: TableSortState = {
  key: PATIENT_NAME_COLUMN_KEY,
  direction: 'asc'
};
